export default "__VITE_ASSET__BQbID9cy__"